import { Instance, types } from 'mobx-state-tree'
import { SelectOption, selectOptionFromString } from 'components/Select/Select'

// Deployment email model
export const OversightDeploymentEmailModel = types.model('OversightDeploymentEmailModel', {
  id: types.identifierNumber,
  email: types.string,
})

// OversightDeploymentModel matching the backend schema
export const OversightDeploymentModel = types
  .model('OversightDeploymentModel', {
    id: types.identifierNumber,
    name: types.string,
    timezone: types.string,
    safe_landing_radius_display_m: types.maybeNull(types.number),
    control_zone_buffer_m: types.maybeNull(types.number),
    no_fly_zone_buffer_m: types.maybeNull(types.number),
    email_addresses: types.array(OversightDeploymentEmailModel),
  })
  .views((self) => ({
    get emailAddresses() {
      return self.email_addresses
    },
    get safeLandingRadiusDisplayM() {
      return self.safe_landing_radius_display_m
    },
    get controlZoneBufferM() {
      return self.control_zone_buffer_m
    },
    get noFlyZoneBufferM() {
      return self.no_fly_zone_buffer_m
    },
    get timezoneAsSelectOption(): SelectOption {
      return selectOptionFromString(self.timezone)
    },
  }))

export type OversightDeployment = Instance<typeof OversightDeploymentModel>
